import { fetchWithChatFeedback } from './chatFeedbackRequired';
/**
 * Best-effort product walkthrough telemetry.
 *
 * This endpoint derives identity from the authenticated session cookie.  Keep
 * this client deliberately small and allow-listed: it must never carry user
 * content, URLs, flow metadata, or a client-provided email address.
 */

const API_BASE_URL = process.env.REACT_APP_API_URL || "";

export enum WalkthroughEvent {
  Started = "walkthrough_started",
  Completed = "walkthrough_completed",
  Dismissed = "walkthrough_dismissed",
}

export const WALKTHROUGH_TOUR_KEYS = [
  "cls-upload",
  "cls-final",
  "cls-results",
  "complex-services-pws-intake",
  "complex-services-pws-context",
  "complex-services-pws-generation-edit",
  "complex-services-607",
  "complex-services-608",
  "complex-services-609",
  "complex-services-610",
  "complex-services-611",
  "complex-services-612",
  "complex-services-613",
  "complex-services-614",
  "complex-services-615",
  "complex-services-616",
  "complex-services-617",
  "complex-services-618",
  "complex-services-619",
  "construction-abstract",
  "fopr-form",
  "fopr-upload",
  "salient-characteristics",
  "generate-questions",
  "homepage",
  "naics",
  "pnm",
  "psc",
  "products",
  "sow-manual-edit",
  "sow-suggestions",
  "sow-upload",
  "saved-workflows",
  "section-b",
  "section-c",
  "section-d",
  "section-e",
  "services-code-selection",
  "services-combo-form",
  "services-combo-upload",
  "services-context-questions",
  "services-manual-edit",
  "services-sow-upload",
  "services-salient",
  "services-suggestions",
  "services-vendor-discovery",
  "post-award-intake",
  "post-award-recommendation",
  "post-award-workspace",
  "synopsis",
  "usage-dashboard",
  "vendor-bids",
  "vendor-discovery",
  "wage-determination",
  "price-realism-estimator",
] as const;

export type WalkthroughTourKey = (typeof WALKTHROUGH_TOUR_KEYS)[number];

/**
 * Send one lifecycle event without changing user-facing tour behavior when
 * telemetry is unavailable. There is intentionally no retry or response-body
 * processing, since duplicate activity records are less useful than a missed
 * best-effort reporting event.
 */
export async function reportWalkthroughActivity(
  event: WalkthroughEvent,
  tourKey: WalkthroughTourKey
): Promise<void> {
  try {
    await fetchWithChatFeedback(`${API_BASE_URL}/api/product-activity`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({ event, tour_key: tourKey }),
    });
  } catch {
    // Telemetry must never prevent a tour, page, or navigation from working.
  }
}
